import React, { useState, createContext, useContext } from 'react';
interface AgentContextType {
  activeAgentId: string;
  setActiveAgentId: (id: string) => void;
}
const AgentContext = createContext<AgentContextType | undefined>(undefined);
export function AgentProvider({
  children
}: {
  children: ReactNode;
}) {
  const [activeAgentId, setActiveAgentId] = useState<string>('1'); // Default to first agent
  return <AgentContext.Provider value={{
    activeAgentId,
    setActiveAgentId
  }} data-id="element-857">
      {children}
    </AgentContext.Provider>;
}
export function useAgent() {
  const context = useContext(AgentContext);
  if (context === undefined) {
    throw new Error('useAgent must be used within an AgentProvider');
  }
  return context;
}